import React, { useEffect, useState } from "react";
import moment from "moment";
import { AESEncryption, ApiResDecrypt, checkDateRange, compareDate, noDataFound } from "../../../CommonMethhods/CommonMethods";
import { Dashboard_Client_Report } from "../../../Configuration/API_URL";
import SmallLoader from "../../../Components/Common/smallLoader";
import { Constants, REPORT_TYPES } from "../../../CommonMethhods/Constants";
import Loader from "../../../Components/Common/Loader";
import ContractListTable, {
  getRowSelectionKey,
  getFileNameFromSelectionKey,
} from "../../../Components/ReportTables/ContractListTable";
import warningIcon from "../../../asset/images/icons/warning.svg";
import errorImage from "../../../asset/images/icons/errorImage.svg";
import { Col, Row, Toast } from "react-bootstrap";
import FromdateComponent from "../../Reports/FromdateComponent";
import TodateComponent from "../../Reports/TodateComponent";
import { toast } from "react-toastify";
import DurationChangeComponent from "../../Reports/DurationChangeComponent";
import axiosInstance from "../../../CommonMethhods/axiosInstance";
import { useDownloadAll } from "../../Reports/useStatementReport";

const SEGMENT = "stocks";
function ContractListReportNew(props) {
  const storeToken = localStorage.getItem("ssoToken");
  const [data, setData] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loader, setLoader] = useState(false);
  const [checkDate, setCheckDate] = useState(false);
  const [smallLoaderMail, setSmallLoaderMail] = useState(false);
  // const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const [error, setError] = useState("");
  const [serverError, setServerError] = useState(false);
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [userFriendList, setUserFriendList] = useState([]);
  const [userFriendlyName, setUserFriendlyName] = useState([]);
  const [mailError, setMailError] = useState("");
  const [customShow, setCustomShow] = useState(false);
  const [selectedReportType, setSelectedReportType] = useState("");
  const [appliedReportType, setAppliedReportType] = useState("");
  const [reportTypeError, setReportTypeError] = useState("");
  let newArr = [];
  const ClientId2 = localStorage.getItem("ClientId2");

  const { isDownloading, downloadAllStatementReport } = useDownloadAll();

  const isContractNote = selectedReportType === "ContractNote";
  const clientCode = localStorage.getItem("clientCode") || ClientId2;

  if (fromDate == "" || toDate == "") {
    // const current = new Date();
    // const CurrentYear = current.getFullYear();
    // const CurrentMonth = current.getMonth();
    // if (CurrentMonth < 4) {
    //   const newYear = `04-01-${CurrentYear - 1}`;
    //   const date = `${current.getMonth() + 1
    //     }-${current.getDate()}-${current.getFullYear()}`;
    //   const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
    //   setFromDate(newYear);
    //   setToDate(date1);
    // } else {
    //   const newYear = `04-01-${CurrentYear}`;
    //   const date = `${current.getMonth() + 1
    //     }-${current.getDate()}-${current.getFullYear()}`;
    //   const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
    //   setFromDate(newYear);
    //   setToDate(date1);
    // }
    let date = new Date();
        let firstDay = "";
        let lastDay = "";
        let firstVal = new Date(date.getFullYear(), date.getMonth(), 1);
        firstDay = moment(firstVal, "MM-DD-YYYY").format("MM-DD-YYYY");
        let lastVal = new Date();
        lastDay = moment(lastVal, "MM-DD-YYYY").format("MM-DD-YYYY");
        setFromDate(firstDay)
        setToDate(lastDay)
  }
  const getContractListReport = async (fileType, e) => {
    if (fileType === "mail") {
      setSmallLoaderMail(true);
      setLoader(false);
    }
    if (fileType === "grid") {
      setSmallLoaderMail(false);
      setLoader(true);
    }
    setServerError(false);
    let payloadValue = {
      clientCode: clientCode,
      fromDate: fromDate,
      toDate: toDate,
      fileType: fileType,
      userContractName: e ? [e] : userFriendList.map(getFileNameFromSelectionKey),
      ...(isContractNote ? {seg: SEGMENT} : {reportType: selectedReportType})
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axiosInstance.post(
        isContractNote ? Dashboard_Client_Report.CONTRACT_NOTE_URL : Dashboard_Client_Report.STATEMENT_REPORT_URL,
        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getDetails?.data);


      if (res?.status === 0) {
        if (res?.data?.length === 0) {
          setServerError("No Data Found");
        }
        if (fileType === "grid") {
          setData(res?.data);
          setAppliedReportType(selectedReportType);
        } else if (fileType === "pdf") {
          window.open(res?.data, "_blank", "noopener,noreferrer");
          toast.success("File downloaded successfully");
        } else if (fileType === "mail") {
          toast.success(res?.message || "Email sent successfully.");
        }
      } else {
        if (fileType !== "grid") {
          toast.error(res?.message);
        }
        if (fileType === "grid") {
          setData([]);
          setServerError(res?.message);
        }
      }
    } catch (error) {
      console.log(error);
      setServerError(error?.message);
      if (fileType !== "grid") {
        toast.error(error?.message);
      }
    } finally {
      setLoader(false);
      setSmallLoaderMail(false);
    }
  };

  const handleFromDateChange = (e) => {
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setFromDate(d);
    // setData([]);
    setError("");
    setMailError("");
    setServerError(false);
  };
  const handleToDateChange = (e) => {
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setToDate(d);
    // setData([]);
    setError("");
    setMailError("");
    // setFileType("")
    setServerError(false);
  };
  // useEffect(() => {
  //   if (localStorage.getItem("clientCode") || ClientId2) {
  //     if (
  //       compareDate(fromDate) &&
  //       compareDate(toDate) &&
  //       checkDateRange(fromDate, toDate)
  //     ) {
  //       getContractListReport("grid");
  //     } else {
  //       setCheckDate(true);
  //     }
  //   }
  // }, []);

  function formatDate(date) {
    return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
  }
  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  const handleOnClick = (e) => {
    setReportTypeError("");

    if (!selectedReportType) {
      setReportTypeError("Please select Report Type.");
      return;
    }

    if (fromDate.length > 0 && toDate.length > 0) {
      if (e.target.value) {
        if (
          compareDate(fromDate) &&
          compareDate(toDate) &&
          checkDateRange(fromDate, toDate)
        ) {
          getContractListReport(e.target.value);
          setError("");
          setMailError("");
          setCheckDate(false);
        } else {
          setCheckDate(true);
          setError("Please Select Correct Date.");
        }
      }
    }
  };

  function getMailData() {
    if (userFriendList.length > 0) {
      getContractListReport("mail");
      // setIsCheckAll(false)
      setUserFriendList([]);
    } else {
      setMailError("Please select at least one Contract Report.");
      setError("");
    }
  }

  function selectAllDeleteSymbolList() {
    setIsCheckAll(!isCheckAll);
  }

  async function handleDownloadDocument(e, id) {
    const oldData = [...data];
    const loaded = oldData.map((item, key) => {
      item.loader = id === key;
      return item;
    });

    if (e) {
      setData(loaded);
      setMailError("");

      await getContractListReport("pdf", e);
      
      const newloaded = data.map((item) => {
        item.loader = false;
        return item;
      });

      setData(newloaded);
    }
  }

  function handleSelectionChange(e) {
    setMailError("");
    setIsCheckAll(false);
    if (data.length >= userFriendList.length) {
      document.getElementById("select-all").checked = false;
    }
    const { value, checked } = e.target;
    if (checked) {
      setUserFriendList((preval) => [...preval, value]);
    } else {
      let newArr = userFriendList.filter((item) => item !== value);
      setUserFriendList(newArr);
    }
  }

  function getAllDeleteSymbol() {
    if (isCheckAll) {
      data.forEach((item, index) => {
        newArr.push(getRowSelectionKey(item, index));
      });
      setUserFriendList(newArr);
    } else {
      if (data.length <= userFriendList.length) {
        setUserFriendList([]);
        setUserFriendlyName([]);
      }
    }
  }

  const onChangeDuration=()=>{
    setError("");
    setMailError("");
    setServerError(false);
  }

  useEffect(() => {
    getAllDeleteSymbol();
  }, [isCheckAll]);

  const handleReportTypeChange = e => {
    setSelectedReportType(e.target.value);
    setReportTypeError("");
  }

  const handleDownloadAllClick = async () => {
    if (userFriendList.length <= 1) {
      return;
    }

    if (isContractNote) {
      await getContractListReport("pdf");
      return;
    }

    const payload = {
      clientCode,
      reportType: appliedReportType,
      fileList : data.filter((item, index) => userFriendList.includes(getRowSelectionKey(item, index)))
                                      .map(item => ({FileName: item.FileName, FolderId: item.FolderId}))
    }
    const encryptedPayload = AESEncryption(payload);
    const { success, data : decryptedData } = await downloadAllStatementReport(encryptedPayload);
    if (success && decryptedData) {
      window.open(decryptedData.data?.fileUrl, "_self", "noopener,noreferrer");
    } else {
      toast.error(decryptedData?.message || "Failed to download reports. Please try again.");
    }
  }

  return (
    <>
      <div
        className="tab-pane fade show active"
        id="contract-list"
        role="tabpanel"
        aria-labelledby="contract-list"
      >
        <div style={{columnGap: "2rem", flexDirection: customShow ? "column" : "row", alignItems: customShow ? "flex-start" : "center"}} className="reports-date-filter">
          <div style={{flexGrow: 1}} className="reports-left-form d-flex w-100">
            <form style={{display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(160px,1fr))", width: "100%"}}>
              {/* <div className="report-form-wrapper"> */}
                <div className="form-group">
                  <label className="form-label">
                    Report Type <span className="required">*</span>{" "}
                  </label>

                  <div className="input-text-wrapper align-items-center">
                    <select
                      className={`input-text form-control report-custom-select w-100`}
                      value={selectedReportType}
                      onChange={handleReportTypeChange}
                    >
                      <option value="" disabled>
                        Please select report type
                      </option>
                      {REPORT_TYPES.map((item, index) => {
                        return (
                          <option key={index} value={item.value}>
                            {item.label}
                          </option>
                        )
                      })}
                    </select>
                  </div>

                  {reportTypeError && (
                    <span style={{left: 0, bottom: "-8px"}}  className="to-date-error">{reportTypeError}</span>
                  )}
                </div>

                <div className="form-group" >
                  <DurationChangeComponent
                    setCustomShow={setCustomShow}
                    setFromDate={setFromDate}
                    setToDate={setToDate}
                    className="report-custom-select w-100"
                    onChangeDuration={onChangeDuration}
                    screen="Client Dashboard"
                  />
                </div>
                {customShow && <FromdateComponent
                  fromDate={handleFromDateChange}
                  formatDate={formatDate(fromDate)}
                  DateReverse={DateReverse}
                />}

                {customShow && <TodateComponent
                  toDate={handleToDateChange}
                  formatToDate={formatDate(toDate)}
                  DateReverse={DateReverse}
                  errorResponse={error}
                />}
              {/* </div> */}
              <div style={{justifySelf: "start"}}>

            <button
              className="generate-button get-data"
              type="button"
              value="grid"
              onClick={handleOnClick}
              >
              {Constants.Submit}
            </button>
              </div>
            </form>

            <div className="report-btn-wrapper">
              <button
                style={{marginRight: "10px"}}
                className="generate-button mail-btn mt-2"
                value="mail"
                onClick={getMailData}
                disabled={userFriendList.length === 0}
              >
                {smallLoaderMail ? (
                  <SmallLoader />
                ) : (
                  <>
                    <span className="icon-email"></span>
                    E-Mail
                  </>
                )}
              </button>

              {userFriendList.length > 1 && (
                  <button
                    className="generate-btn text-green download-btn mt-2"
                    value="download"
                    onClick={handleDownloadAllClick}
                  >
                    {isDownloading ? (
                      <SmallLoader />
                    ) : (
                      <>
                        <span style={{background: "none", padding: "0", color: "inherit"}} className="icon-download"></span>
                        {"Download"}
                      </>
                    )} 
                  </button>
                )}
            </div>
          </div>
        </div>
        <div className="report-btn-wrapper">
          <p className="mail-error">{mailError}</p>
        </div>
      </div>
      {loader ? (
        <div className="loader-alignment">
          <Loader />
        </div>
      ) : (
        data.length > 0 && (
          <div>
            <ContractListTable
              data={data}
              selectAllDeleteSymbolList={selectAllDeleteSymbolList}
              handleSelectionChange={handleSelectionChange}
              handleDownloadDocument={handleDownloadDocument}
              userFriendList={userFriendList}
              isContractNote={isContractNote}
              selectedReportType={appliedReportType}
              clientCode={clientCode}
            />
          </div>
        )
      )}
      {serverError && (
        <div className="report-error-message">{noDataFound(serverError, {position: "static"})}</div>
      )}
    </>
  );
}
export default ContractListReportNew;
